var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShareIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3404",
    "data-name": "Rectangle 3404",
    width: 12,
    height: 12,
    fill: "#2e71fc"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_204",
    "data-name": "Mask Group 204"
  }, /*#__PURE__*/React.createElement("path", {
    id: "__TEMP__SVG__",
    d: "M11.082,9.7a1.841,1.841,0,0,0-1.331.568L5.48,7.862a1.843,1.843,0,0,0,0-.948l4.271-2.4a1.841,1.841,0,1,0-.454-.8L5.026,6.11a1.847,1.847,0,1,0,0,2.557L9.3,11.07A1.847,1.847,0,1,0,11.082,9.7Z",
    transform: "translate(-1.388 -1.391)",
    fill: "#2e71fc"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareIcon);
export default __webpack_public_path__ + "static/media/shareIcon.0ba20289ca353a19c9625882a2654622.svg";
export { ForwardRef as ReactComponent };